import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dir"]

import { onBeforeMount } from 'vue';

import Container from '@/views/client/Container.vue';
import { useLocaleStore } from '@/store/localeList';
import { i18n, setLanguage } from '@/utils/i18n';
import { setErrorMessage } from './utils/serviceUtil';
import { getStaticNCUIPath } from '@/utils/getStaticPath';


export default /*#__PURE__*/_defineComponent({
  __name: 'App_client',
  setup(__props) {

const localStore = useLocaleStore();

// localStore.getItems();
const locale = window._locale as string;
const isRtl = locale.slice(0, 2) == 'ar' ? true : false;
setLanguage(locale.split('_')[0]);
setErrorMessage('DEFAULT_ERROR_MESSAGE');

onBeforeMount(async () => {
  await appendFooterScript();
});

const zone = window._zone ? window._zone : 'ncs';
// footer script body 태그 뒤에 붙이기
const appendFooterScript = async () => {
  const ncuiVersion = window._ncuiVersion || '1.7.4';
  const timestamp = window._timestamp;

  let footerScript = document.createElement('script');
  footerScript.setAttribute(
    'src',
    `${getStaticNCUIPath(zone)}/${ncuiVersion}/js/ncui-footer.js?${timestamp}`
  );
  document.body.appendChild(footerScript);
  window.addEventListener('load', renderFooter);
};

// 로드 된뒤에 푸터 실행하기
const renderFooter = async () => {
  const footerConfig = window._footerConfig;
  if (window.ncui && window.ncui.footer) {
    new window.ncui.footer(footerConfig);
  }

  window.removeEventListener('load', renderFooter);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    dir: _unref(isRtl) ? 'rtl' : 'ltl'
  }, [
    _createVNode(Container)
  ], 8, _hoisted_1))
}
}

})